var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header'),_c('section',{staticClass:"main-content"},[_c('router-view')],1),_c('bottom-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }